import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid } from '@material-ui/core';
import Buttoncontrol from "../../../GeneralUI/Buttoncontrol";
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { TextField, Button } from '@material-ui/core';
import { SnackbarProvider, withSnackbar } from 'notistack';
import AutoComplete from '../../../GeneralUI/AutoComplete';
import PSelect from '../../../GeneralUI/PSelect';
import { combineStyles } from '../../../../Libs';


const styles = theme => ({
  button: {
    margin: theme.spacing(),
  },
  input: {
    display: 'none',
  }
});

class InformeEstadoOcupacion extends Component {

  state = {
    data: [],
    fields: {

      ALMACEN_CODIGO: null,
      PRODUCTO_CODIGO: null,
      CLIENTE_CODIGO: null,
      FECHA_CORTE: null,
      FILTRO_DISPONIBILIDAD: null,
    },
    paramsInforme: '/imprimir_informe/movimientoinventario/informe_estado_ocupacion?ALMACEN_CODIGO=' + null + '&CLIENTE_CODIGO=' + null + '&PRODUCTO_CODIGO=' + null + '&FECHA_CORTE=' + null+'&FILTRO_DISPONIBILIDAD=' + null,
    responseForm: { Message: '', typeMessage: '' },
    formErrors: {
    }
  };

  componentDidMount() {
    const params = this.props.match.params;

    if (!params.id) {
      return;
    }

    
      
  }

  handleSeguir = () => {
    alert('Seguimiento registrado.');
  }

  handleChange = (event) => {
    let { fields } = this.state;
    let params = '';
    fields[event.target.id] = event.target.value;
    this.setState({ fields });

    params = '/imprimir_informe/movimientoinventario/informe_estado_ocupacion?ALMACEN_CODIGO=' + this.state.fields.ALMACEN_CODIGO + '&CLIENTE_CODIGO=' + this.state.fields.CLIENTE_CODIGO + '&PRODUCTO_CODIGO=' + this.state.fields.PRODUCTO_CODIGO + '&FECHA_CORTE=' + this.state.fields.FECHA_CORTE+'&FILTRO_DISPONIBILIDAD='+this.state.fields.FILTRO_DISPONIBILIDAD;
    this.setState({ paramsInforme: params });
  }

  save = (response) => {
    let newState = {
      openSnackbar: true,
      responseForm: response.responseForm
    };

    if (newState.responseForm['typeMessage'] === 'success') {
      newState.data = response.data;
    }

    this.setState(newState);
    this.props.enqueueSnackbar(this.state.responseForm['Message'], { variant: this.state.responseForm['typeMessage'] });
  }

  render() {
    const { classes } = this.props;

    return (

      <Paper elevation={5} className={classes.mainPaper}>
        <form className={this.props.form} onSubmit={e => e.preventDefault()}>

          <Grid container spacing={3} className={classes.gridForm}>

            <InputLabel className={classes.tittleLabelForm}>
              Informe Estado Ocupacion
            </InputLabel>
          </Grid>


          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <AutoComplete
                id="ALMACEN_CODIGO"
                tableName='Almacen'
                fields={['almacenCodigo', 'almacenNombre']}
                primaryField='almacenCodigo'
                aliases={['ID', 'Nombre']}
                searchField='almacenNombre'
                placeHolder='Seleccionar Almacen'
                onSelect={this.handleChange}
                where={{
                  almacenEstado: 'ACTIVO'
                }}
                value={this.state.fields["ALMACEN_CODIGO"]}
                formErrors={this.state.formErrors['almacenCodigo']}
              />
             </Grid>

             <Grid item xs={3} className={this.props.classes.gridForm}>            
              <AutoComplete
                id="CLIENTE_CODIGO"
                tableName='cliente'
                fields={['clienteCodigo', 'clienteRazonSocial']}
                aliases={[{ value: 'ID', size: 1 }, { value: 'Nombre', size: 11 }]}
                size='xl'
                primaryField='clienteCodigo'
                searchField='clienteRazonSocial'
                placeHolder='Seleccionar Cliente'
                onSelect={this.handleChange}
                value={this.state.fields["CLIENTE_CODIGO"]}
              />
            </Grid>
          <Grid item xs={3} className={this.props.classes.gridForm}>
              <AutoComplete
                id="PRODUCTO_CODIGO"
                tableName='producto'
                fields={['productoCodigo', 'productoCodigoMinisterio', 'productoNombre']}
                aliases={[{ value: 'ID', size: 1 }, { value: 'Ministerio', size: 2 }, { value: 'Nombre', size: 9 }]}
                size='xl'
                primaryField='productoCodigo'
                searchField='productoNombre'
                placeHolder='Seleccionar Producto'
                onSelect={this.handleChange}
                value={this.state.fields["PRODUCTO_CODIGO"]}
              />
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <PSelect
                id="FILTRO_DISPONIBILIDAD"
                useChildren={true}
                value={this.state.fields["FILTRO_DISPONIBILIDAD"]}
                onChange={this.handleChange}
                namelabel="Ubicaciones"
              >
                <option value="OCUPADAS">OCUPADAS</option>
              </PSelect>
            </Grid>
            <Grid item xs={3} className={classes.gridForm}>
              <TextField
                id="FECHA_CORTE"
                fullWidth
                margin="normal"
                variant="outlined"
                onChange={this.handleChange}
                value={this.state.fields["FECHA_CORTE"]}
                type="date"
                label="Fecha Corte"
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </form>


        <div id='buttonContainer'>
          <Buttoncontrol
            saveData={this.state.fields}
            moduleName='informe_estado_ocupacion'
            paramsInforme={this.state.paramsInforme}
            save={this.save}
            primaryFields={['pedidoCodigo']}
            url='/imprimir_informe/movimientoinventario/informe_estado_ocupacion'
            isFormLite={true}
          />
        </div>

      </Paper>
    );
  }

}



InformeEstadoOcupacion.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
};

const MyApp = withRouter(withSnackbar(withStyles(combineStyles(styles, Styles))(InformeEstadoOcupacion)));

function IntegrationNotistack() {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp />
    </SnackbarProvider>
  );
}


export default IntegrationNotistack;